@switch (props.templateType) {
	@case (RadioTemplateType.TAB) {
		<ng-container *ngTemplateOutlet="tabTemplate"></ng-container>
	}
	@default {
		<ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
	}
}
<ng-template #defaultTemplate>
	@for (option of props.options | luRadioOptions: field | async; track option.value; let i = $index) {
		<div class="form-check custom-radio" [class.form-check-inline]="props.formCheck === 'inline'">
			<ng-container *ngTemplateOutlet="radioInput; context: { $implicit: option, i: i }"></ng-container>
			<label
				class="form-check-label"
				[for]="id + '_' + i"
				[ngClass]="{ disabled: option.disabled }"
				[attr.aria-label]="props.options?.[i]?.ariaLabel ?? null">
				{{ option.label }}
			</label>
			@if (option?.additionalFields?.length) {
				<formly-form
					class="additional-radio-options"
					[model]="model"
					[fields]="option.additionalFields"
					[form]="form"></formly-form>
			}
		</div>
	}
</ng-template>

<ng-template #tabTemplate>
	<div class="radio-grid-container">
		@for (option of props.options | luRadioOptions: field | async; track option.value; let i = $index) {
			<div
				class="tab"
				[class.tab__selected]="formControl.value === option.value"
				role="radio"
				[attr.aria-checked]="formControl.value === option.value"
				(click)="selectOption(option.value)"
				(keydown)="handleKeydown($event, option.value)">
				<div class="tab__details">
					<div class="tab__details__icon">
						<luds-icon
							[icon]="option.icon"
							[class.selected]="formControl.value === option.value"
							size="medium"></luds-icon>
					</div>
					<label
						class="h-s"
						[for]="id + '_' + i"
						[ngClass]="{ disabled: option.disabled }"
						[attr.aria-label]="props.options?.[i]?.ariaLabel ?? null">
						{{ option.label }}
					</label>
					@if (option.description) {
						<p class="baseline">{{ option.description }}</p>
					}
				</div>
				<div class="tab__radio">
					<ng-container *ngTemplateOutlet="radioInput; context: { $implicit: option, i: i }"></ng-container>
				</div>
			</div>
		}
	</div>
</ng-template>

<ng-template #radioInput let-option let-i="i">
	<input
		type="radio"
		[id]="id + '_' + i"
		class="form-check-input"
		[name]="field.name || id"
		[class.is-invalid]="showError"
		[value]="option.value"
		[formControl]="formControl | fromAbstractToFormControl"
		[formlyAttributes]="field"
		[attr.disabled]="option.disabled || formControl.disabled ? true : null" />
</ng-template>
